<template>
  <!-- 参与的话题 -->
  <div class="hottopic_wapr">
    <van-sticky>
      <NavTitle title="参与话题" v-if="showTitle"/>
    </van-sticky>
    <div class="bg" :style="'background:url('+img+') no-repeat'">
      <div class="hot_title">
        <div>
          <img src="../../assets/image/hopic.png" />
          <span>{{subjectName}}</span>
        </div>
        <p>{{description}}</p>
      </div>
      <div class="modal_bg"></div>
    </div>
    <div class="hottopic_content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <Waterfall
            :minCol="2"
            :maxCol="2"
            :percent="[1,1]"
            :gutterHeight="10"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
          >
            <itemContent
              pageCode="5010802"
              v-for="(item,index) in list"
              :key="index"
              :item="item"
              :likeCount="item.likeCount"
              :like="item.isLike==='y'?true:false"
            />
          </Waterfall>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import itemContent from "./components/itemContent";
import { Waterfall } from "vue2-waterfall";
import http from "@/utils/axios";
import NavTitle from "./components/navTitle";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      showTitle: false,
      pageIndex: 1,
      list: [],
      img: "",
      subjectName: "",
      description: ""
    };
  },
  components: {
    itemContent,
    Waterfall,
    NavTitle
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  methods: {
    onLoad() {
      this.getGroupList();
    },
    onRefresh() {
      setTimeout(() => {
        this.refreshing = false;
        this.list = [];
        this.pageIndex = 1;
        this.getGroupList();
      });
    },
    getGroupList() {
      http({
        url: "/discover/appuser/subject/subjectDiscover",
        method: "POST",
        parmes: {
          subjectId: this.$route.query.hotId,
          pageIndex: this.pageIndex,
          pageSize: 10
        }
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.liteVOPage.pages == 0) {
            this.finished = true;
          } else {
            if (rps.data.liteVOPage.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageIndex++;
            }
            this.list = this.list.concat(rps.data.liteVOPage.list);
          }
          if (!this.subjectName) {
            this.init(rps.data.subject);
          }
          this.loading = false;
        }
      });
    },
    init(item) {
      console.log("init");
      this.img = item.imgUrl;
      this.subjectName = item.subjectName;
      this.description = item.description;
    }
  },
  created() {
    if (window.tools.isWechat()) {
      this.showTitle = false;
    }
    this.$loading.hide();
  }
};
</script>
<style lang="less" scoped>
.hottopic_wapr {
  .bg {
    width: 100%;
    height: 240px;
    display: flex;
    position: relative;
    align-items: center;
    background-size: 100% !important;
    .hot_title {
      font-size: 32px;
      color: #fff;
      z-index: 1;
      padding-left: 40px;
      // background: rgba(0,0,0,.3);
      div {
        display: flex;
        align-items: center;
        padding-bottom: 22px;
        img {
          width: 45px;
          height: 45px;
        }
      }
      p {
        font-size: 24px;
        text-indent: 45px;
      }
    }
    .modal_bg{
      background:rgba(0,0,0,.3);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .hottopic_content {
    background: #fff;
    padding: 20px;
    min-height: 300px;
  }
}
</style>